var swiperCollection;

function initializeSwiper() {
  if (window.innerWidth <= 1024) {
    // Adjust breakpoint for tablets/mobile
    if (!swiperCollection) {
      swiperCollection = new Swiper(".swiper-collection", {
        loop: true,
        slidesPerView: "auto",
        slidesPerGroup: 1,
        spaceBetween: 24,
        navigation: {
          nextEl: ".collection-next",
          prevEl: ".collection-prev",
        },
      });
    }
  } else {
    if (swiperCollection) {
      swiperCollection.destroy(true, true); // Destroy Swiper instance
      swiperCollection = null; // Reset the instance
    }
  }
}

// Initialize on page load
initializeSwiper();

// Re-check on window resize
window.addEventListener("resize", initializeSwiper);
